// extracted by mini-css-extract-plugin
export default {"container":"contents_container__fDr61","noMessage":"contents_noMessage__wxiON","loader":"contents_loader__W90LE"};